module.exports = __webpack_public_path__ + "img/ssBlueSearch.58780725.svg";